import React, { useEffect, useState} from "react";
import styled from 'styled-components';
import back from '../../styles/assets/back_arrow.svg';
import { useLocation, useNavigate } from "react-router-dom";

const getMnemonic: any = () => {
    let walletInfo = localStorage.getItem('gw-wallet-info')
    let seed = ''
    if (walletInfo) {
        seed = JSON.parse(walletInfo).mnemonic
    }
    return seed;
}

const SeedPhraseTitle = styled.div`
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
    color: #FFFFFF;
`;

const DecriptionTitle = styled.div`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #7A7F9E; 
`;


const Decription = styled.div`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0.1px;
    color: #FFFFFF;
    margin-top: 10px;
`;


const Chip = ({title, value}: any) => {
    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minWidth: 60,
            height: '100%',
            backgroundColor: '#141624',
            borderRadius: 8,
            padding: 16,
            margin: 5,
        }}>
            <DecriptionTitle>{title}</DecriptionTitle>
            <Decription>{value}</Decription>
        </div>
    )
}
/**
 * It renders the user's wallet
 */
const NFTDetails = (props: any) => {
    
    const navigate: any = useNavigate();
    const location: any = useLocation();
    const [token, setToken] = useState(location.state);
    const [traits, setTraits] = useState(location.state.token.attributes? location.state.token.attributes: []);
    console.log('token', token);

    const traitsList = traits.map((item: any, index: any) => {
        console.log(item.trait_type, item.value);
        return (
            <Chip key={index} title={item.trait_type} value={item.value} />
        );

    })

    
    useEffect(() => {
        // fetch token traits
        const fetchTokenTraits = async () => {
            const response = await fetch(token.token.externalMetadataUri);
            const data = await response.json();
            if(data.traits) {
                setTraits(data.traits);
            }
        }
        if(token.token.externalMetadataUri) {
            // fetchTokenTraits();
        }
    }, []);

    let isVideo = false;
    if(token.token.imageUri){
        let fileType = token.token.imageUri.split('.').pop();
        // remove the ? at the end aswell
        if(fileType === 'mp4'){
            isVideo = true;
        }
    }
    return (
        <div style={{display:'flex', flexDirection:'column',  backgroundColor:'#0F0F0F', padding: 0}}>
        <div style={{background: 'linear-gradient(180deg, #141624 0%, rgba(20, 22, 36, 0) 100%)'}}>
        <div onClick={() => navigate(-1)} style={{position: 'absolute', top: 0, left: 20}}>
        <img style={{position: 'absolute', top: 20}} src={back} alt='back arrow' className='hover'/>
        <SeedPhraseTitle className='hover' style={{
            display: 'flex',
            marginTop: 16,
            marginLeft: 30,
            alignContent: 'center',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            maxWidth: 250,
        }}>
        {token.token.name} #{token.token.tokenId}
        </SeedPhraseTitle>        
        </div>

        <div style={{display: 'flex', justifyContent: 'center', marginTop: 16, alignContent: 'center'}}>
        {(isVideo) && <video autoPlay muted  controls={false}
            width="200" height="200" style={{
                marginTop: 88,
                borderRadius: 12}}>
            <source src={token.token.imageUri} type="video/mp4"/>
        </video>}
        {(!isVideo) &&
         <img src={token.token.imageUri} alt='token' style={{width: 200, height: 200, marginTop: 88, borderRadius: 12}}/>
        }
        </div>
        <div style={{marginTop: 80, padding: 16}}>
          <DecriptionTitle>Description</DecriptionTitle>
          <Decription>{token.token.description}</Decription>
        </div>
        <div style={{
            display: 'flex',
            flexWrap: 'wrap',
            padding: 11
        }}>
          {traitsList}
        </div>
        </div>
        </div>
    );
    
}

export default NFTDetails;
